import LeadForm from './LeadForm';

export default LeadForm;
